import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'folder-radio-list',
  templateUrl: './folder-radio-list.component.html',
  styleUrls: ['./folder-radio-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FolderRadioListComponent implements OnInit, OnDestroy {
  folderList = [];
  isOficeWorkSpace = false;
  officefolderList = [];
  totalFolders = [];
  subfolderList = [];
  showFolderList = true;
  favoriteSeason;
  currentWorkSpaceId;
  currentUserId;
  currentValutUserId;
  hideForloderSelection = false;
  estate_tab_group_id;
  workSpaceData;
  fulassetList = [];
  isAssetstab = false;
  markSelectOfficeWorspaceDisable = false;
  subscription = new Subscription();
  showFolderValueList = true;
  hideSaveBtn = false;
  fullSubFolderList = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    private cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<FolderRadioListComponent>
  ) {
    this.showFolderList = data['showFolderList'];
    this.subfolderList = data['subfolderList'];
    this.favoriteSeason = data['sleectedValue'];
    this.currentUserId = data?.currentUserId;
  }

  MovetoParent(subfolderList) {
    let parentData = subfolderList.find((x) => x.parent_office_workspace_folder_id != null);

    if (parentData?.parent_office_workspace_folder_id == null || parentData?.parent_office_workspace_folder_id == undefined) {
      this.showFolderList = true;
    } else {
      let officeSubList = [];
      let tempOfficeSubFolderList = this.totalFolders.find((x) => x.id == parentData.parent_office_workspace_folder_id);
      tempOfficeSubFolderList = this.totalFolders.filter(
        (x) => x.parent_office_workspace_folder_id == tempOfficeSubFolderList?.parent_office_workspace_folder_id
      );
      tempOfficeSubFolderList.forEach((element, index) => {
        let tElement = element;
        if (this.totalFolders.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
          tElement = Object.assign({}, tElement, { isChildAvailable: true });
        } else {
          tElement = Object.assign({}, tElement, { isChildAvailable: false });
        }
        officeSubList.push(tElement);
      });
      this.subfolderList = officeSubList;
    }
  }
  MovetoChild(item) {
    let saveFilterdata = [];
    let filterData = this.totalFolders.filter((x) => x.parent_office_workspace_folder_id == item.id);
    filterData.forEach((element, index) => {
      let tElement = element;
      if (this.totalFolders.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
        tElement = Object.assign({}, tElement, { isChildAvailable: true });
      } else {
        tElement = Object.assign({}, tElement, { isChildAvailable: false });
      }
      saveFilterdata.push(tElement);
    });
    this.subfolderList = saveFilterdata;
  }
  movetoFolderlist() {
    this.showFolderList = false;
    let saveFilterdata = [];
    let filterData = this.totalFolders.filter((x) => x.parent_office_workspace_folder_id == null);
    filterData.forEach((element, index) => {
      let tElement = element;
      if (this.totalFolders.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
        tElement = Object.assign({}, tElement, { isChildAvailable: true });
      } else {
        tElement = Object.assign({}, tElement, { isChildAvailable: false });
      }
      saveFilterdata.push(tElement);
    });
    this.subfolderList = saveFilterdata;
  }
  ngOnInit(): void {
    if (this.data?.isOficeWorkSpace) {
      this.isOficeWorkSpace = true;
      var test = JSON.parse(JSON.stringify(this.data['folderList']));
      this.workSpaceData = test;
      if (this.data?.folderList?.officeWorkspaceFolders) {
        this.totalFolders = JSON.parse(JSON.stringify(this.data['folderList']['officeWorkspaceFolders']));
      }

      if (this.data['subfolderList']?.length) {
        this.totalFolders = JSON.parse(JSON.stringify(this.data['subfolderList']));
      }

      Object.preventExtensions(test);
      this.folderList.push(test);
    } else {
      this.data['folderList'].forEach((element) => {
        var test = JSON.parse(JSON.stringify(element));
        test.is_open = false;
        Object.preventExtensions(test);
        this.folderList.push(test);
      });
    }
    if (this.data?.hideForloderSelection) {
      this.hideForloderSelection = this.data?.hideForloderSelection;
    }
    if (this.data?.currentValutUserId) {
    }
    if (this.router.url.includes('/vault/folder/')) {
      this.setDefualtFoder();
    }
    if (this.router.url.includes('/vault/')) {
      this.hideSaveBtn = true;
    }
    if (this.router.url.includes('/vault/my-workspace/')) {
      this.setDefualtFoderListOffice();
    }
  }
  setDefualtFoderListOffice() {
    const url = this.router.url.split('/');
    if (url.length > 5 && url[5]) {
      let find = this.totalFolders.find((x) => x.id == url[5]);
      if (find) {
        this.subfolderList = this.totalFolders.filter((x) => x.parent_office_workspace_folder_id == find.parent_office_workspace_folder_id);
      }
    } else {
    }
  }
  setDefualtFoder() {
    const url = this.router.url.split('/');
    if (url.length > 5 && url[5]) {
      this.folderList.forEach((element) => {
        element.subfolders.forEach((ChildelementList) => {
          if (ChildelementList.vault_user_folder_id == url[5]) {
            this.showFolderValueList = false;
            let test = [];
            let groupList = [];
            element.subfolders.forEach((SubChildelement) => {
              let newelement = {
                ...SubChildelement,
                ...{ isChildAvailable: false },
              };
              if (element.subfolders.findIndex((x) => x.parent_vault_user_folder_id == SubChildelement.vault_user_folder_id) != -1) {
                newelement.isChildAvailable = true;
              }
              test.push(newelement);
            });
            ChildelementList?.groups.forEach((element) => {
              let newelement = {
                ...element,
                ...{ isGroup: true },
              };
              newelement['id'] = 'group_' + newelement['id'];
              groupList.push(newelement);
            });
            this.fullSubFolderList = test;
            this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == ChildelementList.parent_vault_user_folder_id);
            this.subfolderList = this.subfolderList.concat(groupList);
          }
        });
      });
    } else {
      this.folderList.forEach((element) => {
        if (element.vault_user_folder_id == url[3]) {
          this.showFolderValueList = false;
        }
      });
    }
  }
  EstateFolderList(Estateid) {}
  deleteOption(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();

    let test = [];

    option.subfolders.forEach((element) => {
      let newelement = {
        ...element,
        ...{ isChildAvailable: false },
      };
      if (option.subfolders.findIndex((x) => x.parent_vault_user_folder_id == element.vault_user_folder_id) != -1) {
        newelement.isChildAvailable = true;
      }
      test.push(newelement);
    });

    this.fullSubFolderList = test;
    this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == option.vault_user_folder_id);
    let groupList = [];
    option.groups.forEach((element) => {
      let newelement = {
        ...element,
        ...{ isGroup: true },
      };
      newelement['id'] = 'group_' + newelement['id'];
      groupList.push(newelement);
    });
    this.subfolderList = this.subfolderList.concat(groupList);
    this.showFolderValueList = false;
  }
  moveToPrevious(ev: Event, item) {
    let filterItem = item.find((x) => x.parent_vault_user_folder_id != null);
    if (filterItem == null || filterItem == undefined) {
      filterItem = this.fullSubFolderList.find((x) => x.vault_user_folder_id == item[0].vault_user_folder_id);
      if (filterItem) {
        this.showFolderValueList = false;
        this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == filterItem.parent_vault_user_folder_id);
        if (this.subfolderList.length > 0) {
          let filterGroup = this.fullSubFolderList.find((x) => x.vault_user_folder_id == this.subfolderList[0].parent_vault_user_folder_id);
          if (filterGroup == undefined || filterGroup == null) {
            filterGroup = this.folderList.find((x) => x.vault_user_folder_id == this.subfolderList[0].parent_vault_user_folder_id);
          }
          let groupList = [];
          filterGroup.groups.forEach((element) => {
            let newElement = {
              ...element,
              ...{ isGroup: true },
            };
            newElement['id'] = 'group_' + newElement['id'];
            groupList.push(newElement);
          });
          this.subfolderList = this.subfolderList.concat(groupList);
        } else {
          this.showFolderValueList = true;
          this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == null);
        }
      } else {
        this.showFolderValueList = true;
        this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == null);
      }
    } else {
      if (filterItem?.parent_vault_user_folder_id) {
        let filertDate = this.fullSubFolderList.find((x) => x.vault_user_folder_id == filterItem.parent_vault_user_folder_id);
        if (filertDate == undefined || filertDate == null) {
          this.showFolderValueList = true;
          this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == null);
        } else {
          this.showFolderValueList = false;
          this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == filertDate.parent_vault_user_folder_id);
          if (this.subfolderList.length > 0) {
            let filterGroup = this.fullSubFolderList.find((x) => x.vault_user_folder_id == this.subfolderList[0].parent_vault_user_folder_id);
            if (filterGroup == undefined || filterGroup == null) {
              filterGroup = this.folderList.find((x) => x.vault_user_folder_id == this.subfolderList[0].parent_vault_user_folder_id);
            }
            let groupList = [];
            filterGroup.groups.forEach((element) => {
              let newElement = {
                ...element,
                ...{ isGroup: true },
              };
              newElement['id'] = 'group_' + newElement['id'];
              groupList.push(newElement);
            });
            this.subfolderList = this.subfolderList.concat(groupList);
          }
        }
      }
    }
    ev.stopPropagation();
    ev.preventDefault();
  }
  moveToSub(ev: Event, item) {
    this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == item.vault_user_folder_id);

    let groupList = [];
    item.groups.forEach((element) => {
      let newelement = {
        ...element,
        ...{ isGroup: true },
      };
      newelement['id'] = 'group_' + newelement['id'];
      groupList.push(newelement);
    });
    this.subfolderList = this.subfolderList.concat(groupList);
    this.cd.detectChanges();
    ev.stopPropagation();
    ev.preventDefault();
  }
  closedialog() {
    const data = {
      save: false,
      saveto: this.favoriteSeason,
    };
    this.dialogRef.close(data);
  }
  sveGroupId(id, item) {
    this.favoriteSeason = id;
    const data = {
      save: true,
      groupId: item.id,
      saveto: this.favoriteSeason,
    };
    this.dialogRef.close(data);
  }
  saveData(id) {
    this.favoriteSeason = id;
    this.save();
  }

  save() {
    const data = {
      save: true,
      saveto: this.favoriteSeason,
    };
    this.dialogRef.close(data);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
